import { PdfViewerToolbarButton } from '../../PdfViewerToolbarButton'

import {
  PDF_VIEWER_TOOLBAR_PAN_ICON_PROPS,
  QA_NAME_PDF_VIEWER_TOOLBAR_PAN_MODE_BTN,
} from './PdfViewerToolbarPanTool.constants'

function PdfViewerToolbarPanTool({ isPanMode, onTogglePanMode }) {
  return (
    <PdfViewerToolbarButton
      iconProps={PDF_VIEWER_TOOLBAR_PAN_ICON_PROPS}
      isActive={isPanMode}
      qaName={QA_NAME_PDF_VIEWER_TOOLBAR_PAN_MODE_BTN}
      titleKey='PdfViewer.PanModeBtnKey'
      onClick={onTogglePanMode}
    />
  )
}

export default PdfViewerToolbarPanTool
